import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomActivosFijosBodegasNitSxSedes
 * @author: Juan Camilo Villa
 * @version: jdesk_1.01.0002
 **/
class CustomActivosFijosBodegasNitSxSedes extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);
        this.arrayObjetos = new Map();
        this.arrayCampos = new Map();
        this.crearRegistro = this.crearRegistro.bind(this);
        this.successCrear = this.successCrear.bind(this);
        this.actualiarRegistro = this.actualiarRegistro.bind(this);
        this.successActualizar = this.successActualizar.bind(this);

        this.traerPrimero = this.traerPrimero.bind(this);
        this.successtraerPrimero = this.successtraerPrimero.bind(this);
        this.traerUltimo = this.traerUltimo.bind(this);
        this.successtraerUltimo = this.successtraerUltimo.bind(this);
        this.traerPorId = this.traerPorId.bind(this);
        this.successtraerPorId = this.successtraerPorId.bind(this);
        this.validarRegistroEliminar = this.validarRegistroEliminar.bind(this);
        this.succesvalidarRegistroEliminar = this.succesvalidarRegistroEliminar.bind(this);
        this.eliminarPorId = this.eliminarPorId.bind(this);
        this.successeliminarPorId = this.successeliminarPorId.bind(this);
        this.btnModificar = false;
        this.onClickChange = this.handlerClickChange.bind(this);
        this.onClickShowTable = this.handerClickShowTable.bind(this);
        this.onClickNew = this.handlerClickNew.bind(this);
        this.onClickDelete = this.handlerClickDelete.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.registro_seleccionado = false;
        this.mostrarMensajeSeleccionModificar = this.mostrarMensajeSeleccionModificar.bind(this);
        this.mostrarMensajeSeleccionEliminar = this.mostrarMensajeSeleccionEliminar.bind(this);
        this.successValidarUniqueRegistro = this.successValidarUniqueRegistro.bind(this);
        this.traerTodos = this.traerTodos.bind(this);
        this.successtraerTodos = this.successtraerTodos.bind(this);
        this.confirmarEliminacionRegistro = this.confirmarEliminacionRegistro.bind(this);
        this.cargarSelectEstadosActivos = this.cargarSelectEstadosActivos.bind(this);


        //imprimir
            
        this.mostrarMensajeNoHayDatos                         =this.mostrarMensajeNoHayDatos.bind(this);
        
        this.mostrarMensajeAdicional                         =this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando                         =this.mostrarMensajeGenerando.bind(this);
        this.validRangoFechas                               = this.validRangoFechas.bind(this);



        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.llenar = this.llenar.bind(this);
        this.traer_por_id = true;
        this.operacion_actual = '';
        this.nombre_archivo = 'listado_activos_fijos_bodegas';
        this.sucursal_ingreso ='';
        this.arrayEstadosActivos = [{'id': 1, 'value': 'Activa'}, {'id': 2, 'value': 'Inactiva'},{'id': 3, 'value': 'Suspendida'},{'id': 4, 'value': 'Bloqueada'}];
        this.estado_ciudades = false;
        this.llenarCiudad = false;

    }


    initForm() {
        console.log('Formulario CustomActivosFijosBodegasNitSxSedes,  @version: jdesk_1.01.0004, @author:Juan Camilo Villa,')
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;

        this.arrayCampos.set(1, 'activos_fijos_bodegas_nitsx_sedes_id');
        this.arrayCampos.set(2, 'nitsx_sedes_id');
        this.arrayCampos.set(3, 'activos_fijos_bodegas_id');
        this.arrayCampos.set(4, 'codigo_bodega');
        this.arrayCampos.set(5, 'descripcion_bodega');
        this.arrayCampos.set(6, 'tipo_bodega');
        this.arrayCampos.set(7, 'nit');
        this.arrayCampos.set(8, 'sede');
        this.arrayCampos.set(9, 'nombre');
        this.arrayCampos.set(10, 'estadoactivo_id');
        this.arrayCampos.set(11, 'fecha_inicial');
        this.arrayCampos.set(12, 'fecha_final');
        this.arrayCampos.set(13, 'label_form');


        this.arrayCampos.set(30, 'btn_agregar');
        this.arrayCampos.set(31, 'btn_cancelar');
        this.arrayCampos.set(32, 'btn_modificar');
        this.arrayCampos.set(33, 'btn_cancelar_modificar');

        this.arrayObjetos.set(1, 'activos_fijos_bodegas_nitsx_sedes_id');
        this.arrayObjetos.set(2, 'nitsx_sedes_id');
        this.arrayObjetos.set(3, 'activos_fijos_bodegas_id');
        this.arrayObjetos.set(4, 'codigo_bodega');
        this.arrayObjetos.set(5, 'descripcion_bodega');
        this.arrayObjetos.set(6, 'tipo_bodega');
        this.arrayObjetos.set(7, 'nit');
        this.arrayObjetos.set(8, 'sede');
        this.arrayObjetos.set(9, 'nombre');
        this.arrayObjetos.set(10, 'estadoactivo_id');
        this.arrayObjetos.set(11, 'fecha_inicial');
        this.arrayObjetos.set(12, 'fecha_final');
        this.arrayObjetos.set(13, 'label_form');

        this.arrayObjetos.set(30, 'btn_agregar');
        this.arrayObjetos.set(31, 'btn_cancelar');
        this.arrayObjetos.set(32, 'btn_modificar');
        this.arrayObjetos.set(33, 'btn_cancelar_modificar');

        this.establecerPropiedades('1,2,3,4,5,7,8,9,10,11,12', 'visible', 'false')
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12', 'disable', 'true')

        //inicio form
        this.establecerPropiedades('4,5,6,7,8,9,10,11,12', 'visible', 'true');

/*         this.getField('fecha_inicial').setOnChange(()=>{ 
            this.validRangoFechas();
        }); */
        this.getField('fecha_final').setOnChange(()=>{ 
            if(Date.parse(this.getField("fecha_final").getValue()) >= Date.parse(this.getField("fecha_inicial").getValue()))
                this.getField('fecha_final').setError(false,'');
        });



        this.getField('btn_cancelar').setClick(() => {
            this.traer_por_id = false;
            this.btnCancelarRegistro();
        });
        this.getField('btn_agregar').setClick(() => {
            if (this.getField("activos_fijos_bodegas_id").valid() && this.getField("nitsx_sedes_id").valid() &&
            this.getField("codigo_bodega").valid() && this.getField("descripcion_bodega").valid() &&
            this.getField("tipo_bodega").valid() && this.getField("nit").valid()&&
            this.getField("sede").valid() && this.getField("nombre").valid() && 
            this.getField("estadoactivo_id").valid() && this.getField("fecha_inicial").valid()&&
            this.getField("fecha_final").valid()
        )
            if(Date.parse(this.getField("fecha_final").getValue()) < Date.parse(this.getField("fecha_inicial").getValue())){
                this.getField('fecha_final').setError(true,'* La fecha final no puede ser menor a la fecha inicial');
             }else{
                this.getField('fecha_final').setError(false,'');
                this.validacionUnique();
            }
               /* this.crearRegistro(); */
                
        });

        this.getField('btn_modificar').setClick(() => {
            if (this.getField('codigo_bodega').valid() && this.getField('nit').valid() && this.getField('estadoactivo_id').valid()){
                if(Date.parse(this.getField("fecha_final").getValue()) < Date.parse(this.getField("fecha_inicial").getValue())){
                    this.getField('fecha_final').setError(true,'* La fecha final no puede ser menor a la fecha inicial');
                 }else{
                     this.actualiarRegistro();
                 }

            }
                /* this.validacionUnique(); */
        });

        this.getField('btn_cancelar_modificar').setClick(() => {
            this.traer_por_id = false;
            this.btnModificar = false;
            this.btnCancelarRegistro();
        });


/*         this.cargarSelectEstadosActivos();
        this.traerUltimo(); */


    }

    validRangoFechas(){
/*         let fecha_desde = new Date(this.getField('fecha_inicial').getValue());
        let  fd = new Date(fecha_desde.getFullYear()+ "/" + (fecha_desde.getMonth() +1) + "/" + fecha_desde.getDate());
        let fecha_hasta = new Date(this.getField('fecha_final').getValue());
        let  fh = new Date(fecha_hasta.getFullYear() + "/" + (fecha_hasta.getMonth() +1) + "/" + fecha_hasta.getDate() ); */
        
/*         let rango = Math.round(((fh.getTime() - fd.getTime()) / (1000*60*60*24)));
        
/*         if(campo_fecha === 'fd'){
            if(rango < -1){
                this.valid_fecha_desde = false;
                this.getField('fecha_desde').setError(true,'* La fecha desde debe ser menor o igual a la fecha hasta');
                this.getField('consultar').setDisabled(true);
            } else if(rango >= 59){
                this.valid_fecha_desde = false;
                this.getField('fecha_desde').setError(true,'* El rango de fecha debe ser máximo de 60 días');
                this.getField('consultar').setDisabled(true);
            } else{
                
                let validFechaHasta = this.validarFechaMenorActual(this.getField('fecha_hasta').getValue());//
        
                if(!validFechaHasta){
                    this.getField('fecha_hasta').setError(true,'* La fecha debe ser menor o igual a la fecha actual');
                    this.valid_fecha_hasta=false;
        
                } else {
                    this.getField('fecha_hasta').setError(false,'');
                    this.valid_fecha_hasta=true;
                }
                //this.getField('fecha_hasta').setError(false,'');
                this.getField('fecha_desde').setError(false,'');
                this.valid_fecha_desde = true;
                //this.valid_fecha_hasta = true;

            }
        }else if(campo_fecha === 'fh'){
            if(rango < 1){
                this.getField('fecha_hasta').setError(true,'* La fecha hasta debe ser mayor o igual a la fecha desde');
                this.valid_fecha_hasta = false;
                this.getField('consultar').setDisabled(true);
            }else if(rango >= 61){
                this.getField('fecha_hasta').setError(true,'* El rango de fechas debe ser máximo de 60 días');
                this.valid_fecha_hasta = false;
                this.getField('consultar').setDisabled(true);
            }else{
                this.valid_fecha_hasta = true;
                this.valid_fecha_desde = true;

                this.getField('fecha_hasta').setError(false,'');
                this.getField('fecha_desde').setError(false,'');

            }
        } */
    }

    cargarSelectEstadosActivos() {

        if (this.arrayEstadosActivos.length > 0) {
            let opciones = [{ 'text': 'Ninguno', 'value': ' ', 'campos_cambian': {} }];
            this.arrayEstadosActivos.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.value;
                /* dataOp['campos_cambian'] = { rack: item.id }; */
                opciones.push(dataOp);
            });
            this.getField('estadoactivo_id').setOptions(opciones);
        } 


    }

    onSelectionChanged() {
        let filaSeleccionada = this.gridOptionsTableDefault.api.getSelectedRows();
        if (filaSeleccionada.length > 0) {
            this.llenar(filaSeleccionada);
            this.registro_seleccionado = true;
        } else {
            this.registro_seleccionado = false;
        }
    }

    handerClickShowTable() {
        this.llenarCiudad = true;
        this.registro_seleccionado = false;
        this.traer_por_id = false;
        /* this.traerPrimero(); */
        this.traerTodos();

    }

    handlerClickChange() {
        this.btnModificar = true;
        if (this.registro_seleccionado) {
            this.registro_seleccionado = false;
            this.establecerPropiedades('4,5,6,7,8,9,10,11,12,32,33', 'disable', 'false');
            this.establecerPropiedades('32,33', 'visible', 'true');
            this.getField('btn_new').setVisible(false);
            this.getField('btn_show').setVisible(false);
            this.getField('btn_change').setVisible(false);
            this.getField('btn_delete').setVisible(false);
            this.getField('rejilla').toggle(false);
            /* this.getField('btn_imprimir').setVisible(false); */

            /* this.getField('departamento_geografico_id_1').setValue(this.getField('departamento_geografico_id_1').getValue()); */


        } else {
            this.mostrarMensajeSeleccionModificar();
        }
    }

    handlerClickNew() {
        this.btnModificar = false;
        this.registro_seleccionado = false;
        this.establecerPropiedades('3,4,5,6,7,8,9,10,11,12,30,31', 'disable', 'false');
        this.establecerPropiedades('30,31', 'visible', 'true');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12', 'value', '');


        this.getField('btn_new').setVisible(false);
        this.getField('btn_show').setVisible(false);
        this.getField('btn_change').setVisible(false);
        this.getField('btn_delete').setVisible(false);
        this.getField('rejilla').toggle(false);
       /*  this.getField('btn_imprimir').setVisible(false); */
/*         this.getField('ciudad_id_1').setValue(' ');
        let opciones = [{ 'text': 'Ninguno', 'value': ' ', 'campos_cambian': {} }];
        this.getField('ciudad_id_1').setOptions(opciones); */

    }

    handlerClickDelete() {
        this.traer_por_id = false;
        if (this.registro_seleccionado) {
            this.confirmarEliminacionRegistro();
            this.registro_seleccionado = false;
        } else {
            this.mostrarMensajeSeleccionEliminar();
        }
    }

    mostrarMensajeSeleccionModificar() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No se ha seleccionado ningún registro para modificar');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeSeleccionEliminar() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No se ha seleccionado ningún registro para eliminar');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    btnCancelarRegistro() {
        this.getField('confirmModalCustom').toggle(false);
        this.registro_seleccionado = false;
        this.getField('btn_agregar').setVisible(false);
        this.getField('btn_cancelar').setVisible(false);
        this.getField('btn_modificar').setVisible(false);
        this.getField('btn_cancelar_modificar').setVisible(false);
        this.getField('btn_new').setDisabled(false);
        this.getField('btn_show').setDisabled(false);
        this.getField('btn_delete').setDisabled(false);

        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12', 'disable', 'true');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12', 'value', '');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12', 'error', 'false');
        if (this.traer_por_id)
            this.traerPorId();
        else
            this.traerUltimo();
        this.traerTodos();


        this.getField('btn_new').setVisible(true);
        this.getField('btn_show').setVisible(true);
        this.getField('btn_change').setVisible(true);
        this.getField('btn_delete').setVisible(true);

/*         this.gridOptionsTableDefault["rowData"] = [];
        this.getField('rejilla').initData(this.gridOptionsTableDefault);
        this.getField('rejilla').toggle(false); */
        this.btnModificar = false;
    }

    validacionUnique() {    
        if (this.getField('activos_fijos_bodegas_id').getValue() !== '' && this.getField('activos_fijos_bodegas_id').getValue() !== ' ' && 
        this.getField('nitsx_sedes_id').getValue() !== '' && this.getField('nitsx_sedes_id').getValue() !== ' '
        ) {
            let datos = {
                datos: {
                    activos_fijos_bodegas_id: this.getField('activos_fijos_bodegas_id').getValue(),
                    nitsx_sedes_id: this.getField('nitsx_sedes_id').getValue(),
                }
            };
            let operacion = '20';
            
/*             if (this.btnModificar) {
                datos.datos['activos_fijos_bodegas_id'] = this.getField('activos_fijos_bodegas_id').getValue();
                operacion = '20_modificar';
            } */
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbodegasnit', operacion: operacion, operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successValidarUniqueRegistro,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        } 
    }

    successValidarUniqueRegistro(data) {
        if (data.estado_p === 200) {
            this.alertGeneral.toggle(true, 'la bodega y el nit ya se encuentra asignado a un registro', 'error');
        } else if(data.estado_p === 404){
            this.crearRegistro();

        }
    }

    traerPorId() {
        let id_bodega = (this.getField('activos_fijos_bodegas_id').getValue() === null ||
        this.getField('activos_fijos_bodegas_id').getValue() !== '' || 
        this.getField('activos_fijos_bodegas_id').getValue() !== ' ' || 
        !isNaN(this.getField('activos_fijos_bodegas_id').getValue()) )
        ?  parseInt(localStorage.getItem('activos_fijos_bodegas_id')):
        this.getField('activos_fijos_bodegas_id').getValue();


        if (id_bodega !== '' && id_bodega !== ' ' && id_bodega !== null && !isNaN(id_bodega) ) {
            let datos = {
                datos: {
                    activos_fijos_bodegas_id: id_bodega
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbodegasnit', operacion: '2', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successtraerPorId,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
            }
    }

    successtraerPorId(data) {
        if (data.estado_p === 200) {
            this.llenar(data.data)
        } /* else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'Error obteniendo el registro', 'error');
            }
        } */
    }

    confirmarEliminacionRegistro() {
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Está seguro de realizar esta acción?');
        this.getField('confirmModalCustom').setClickDialog(this.eliminarPorId);
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
            this.getField('confirmModalCustom').toggle(false);
            this.registro_seleccionado = true;
             });
        this.getField("confirmModalCustom").setVisibleCancel(false);
        this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
        this.getField('confirmModalCustom').toggle(true);
    }

    validarRegistroEliminar() {
        /* this.getField('confirmModalCustom').toggle(false); */
        this.eliminarPorId();
    }

    succesvalidarRegistroEliminar(data) {
        if (data.data[0].cuantos === 0) {
            this.eliminarPorId();

        } else {
            this.alertGeneral.toggle(true, '* Este registro ya está siendo utilizado en otro formulario, no se puede eliminar', 'error')
            this.getField('confirmModalCustom').toggle(false);

        }
    }

    eliminarPorId() {
        let datos = {
            datos: {
                activos_fijos_bodegas_nitsx_sedes_id: this.getField('activos_fijos_bodegas_nitsx_sedes_id').getValue()
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbodegasnit', operacion: '7', operacion_tipo: 'eliminar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: datos,
                success: this.successeliminarPorId,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage : false
            });
    }

    successeliminarPorId(data) {
        if (data.estado_p === 200) {
            this.getField('confirmModalCustom').toggle(false);
            this.traerPrimero();
            this.traerTodos();
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            } else if (data.estado_p === 502) {
                /* let respuesta = Object.values(data.data.errores); */
                let mensajeError = ' Este registro se está usando en otro formulario, no se puede eliminar'  
                this.alertGeneral.toggle(true, mensajeError, 'error');
                this.getField('confirmModalCustom').toggle(false);
            
            } else {
                this.alertGeneral.toggle(true, 'No se pudo eliminar el registro', 'error');
                this.getField('confirmModalCustom').toggle(false);
            }
        }
    }

    crearRegistro() {
        if (this.getField("activos_fijos_bodegas_id").valid() && this.getField("nitsx_sedes_id").valid() &&
        this.getField("codigo_bodega").valid() && this.getField("descripcion_bodega").valid() &&
        this.getField("tipo_bodega").valid() && this.getField("nit").valid()&&
        this.getField("sede").valid() && this.getField("nombre").valid() && 
        this.getField("estadoactivo_id").valid() && this.getField("fecha_inicial").valid()&&
        this.getField("fecha_final").valid() ) {
                
            let datos = {
                datos: {
                    activos_fijos_bodegas_id: parseInt(this.getField("activos_fijos_bodegas_id").getValue()),
                    nitsx_sedes_id: parseInt(this.getField("nitsx_sedes_id").getValue()),
                    fecha_inicial: this.getField("fecha_inicial").getValue(),
                    fecha_final: this.getField("fecha_final").getValue(),
                    estadoactivo_id: parseInt(this.getField("estadoactivo_id").getValue())
                }};

                this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbodegasnit', operacion: '5', operacion_tipo: 'crear' };
                this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method: 'POST',
                        body: datos,
                        success: this.successCrear,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                    });
             

        }
    }

    successCrear(data) {
        if (data.estado_p === 200) {
            this.getField('activos_fijos_bodegas_id').setValue(data.data[0].activos_fijos_bodegas_id);
            this.traer_por_id = true;
            this.btnCancelarRegistro();
            this.traerUltimo()
        } else {
            if (data.estado_p === 502) {
                let respuesta = Object.values(data.data.errores);
                let mensajeError = 'Error, la bodega y el nit ya están asociados a un registro ';
                if (respuesta.toString().includes('"activos_fijos_bodegas_nitsx_sedes_unique"')) {
                   mensajeError = 'La Bodega y el nit ya están asociados a un registro'  
                }else{
                    mensajeError = 'Error creando el registro';
                } 
                this.alertGeneral.toggle(true, mensajeError , 'error');
            
            }else{
                this.alertGeneral.toggle(true, 'No se pudo crear el registro' , 'error');
            }

        }
    }

    actualiarRegistro() {
        if (this.getField("activos_fijos_bodegas_id").valid() && this.getField("nitsx_sedes_id").valid() &&
        this.getField("codigo_bodega").valid() && this.getField("descripcion_bodega").valid() &&
        this.getField("tipo_bodega").valid() && this.getField("nit").valid()&&
        this.getField("sede").valid() && this.getField("nombre").valid() && 
        this.getField("estadoactivo_id").valid() && this.getField("fecha_inicial").valid()&&
        this.getField("fecha_final").valid() ) {

                

            let datos = {
                datos: {
                    activos_fijos_bodegas_nitsx_sedes_id: parseInt(this.getField('activos_fijos_bodegas_nitsx_sedes_id').getValue()),
                    activos_fijos_bodegas_id: parseInt(this.getField("activos_fijos_bodegas_id").getValue()),
                    nitsx_sedes_id: this.getField("nitsx_sedes_id").getValue(),
                    fecha_inicial: this.getField("fecha_inicial").getValue(),
                    fecha_final: this.getField("fecha_final").getValue(),
                    estadoactivo_id: parseInt(this.getField("estadoactivo_id").getValue())
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbodegasnit', operacion: '6', operacion_tipo: 'modificar' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: datos,
                    success: this.successActualizar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false

                });
        }
    }

    successActualizar(data) {
        if (data.estado_p === 200) {
/*             this.getField('activos_fijos_bodegas_id').setValue(data.data[0].activos_fijos_bodegas_id);
            localStorage.setItem('activos_fijos_bodegas_id', this.getField('activos_fijos_bodegas_id').getValue().toString())
            this.traer_por_id = true; */
            this.btnCancelarRegistro();
        }else {
            if (data.estado_p === 502) {
                let respuesta = Object.values(data.data.errores);
                let mensajeError = 'Error, la bodega y el nit ya están asociados a un registro ';
                if (respuesta.toString().includes('"activos_fijos_bodegas_nitsx_sedes_unique"')) {
                   mensajeError = 'La Bodega y el nit ya están asociados a un registro'  
                }else{
                    mensajeError = 'Error actualizando el registro';
                } 
                this.alertGeneral.toggle(true, mensajeError , 'error');
            
            }else{
                this.alertGeneral.toggle(true, 'No se pudo actualizar el registro' , 'error');
            }

        }
    }


    traerTodos() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbodegasnit', operacion: '1', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerTodos,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successtraerTodos(data) {
        if (data.estado_p === 200) {
            //armar tabla
            let configCell = new Map();
            configCell.set('estadoactivo_id', { cellRenderer: (props) => { return "" + props.data.estadoactivo_id }, hide: true });
            configCell.set('activos_fijos_bodegas_id', { cellRenderer: (props) => { return "" + props.data.activos_fijos_bodegas_id }, hide: true });
/*             configCell.set('nombre_departamento', { cellRenderer: (props) => { return "" + props.data.nombre_departamento }, headerName: 'Departamento' });
            configCell.set('nombre_ciudad', { cellRenderer: (props) => { return "" + props.data.nombre_ciudad }, headerName: 'Ciudad' }); */



            this.gridOptionsTableDefault['rowData'] = data.model;//los datos del servicio se cargan en la tabla por defecto del crud
            this.gridOptionsTableDefault['onSelectionChanged'] = this.onSelectionChanged;
            this.getField('rejilla').initData(this.gridOptionsTableDefault, configCell);
/*             this.getField('btn_imprimir').setVisible(true);
            this.getField('btn_imprimir').setDisabled(false); */
            this.registro_seleccionado = false;
        }
        else {
            /* this.getField('btn_imprimir').setVisible(false); */
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }
            else {

                this.alertGeneral.toggle(true, 'Error al traer todos los registros', 'error');
            }
        }
    }

    traerPrimero() {
        this.llenarCiudad = true;
        this.estado_ciudades = true;
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbodegasnit', operacion: '3', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerPrimero,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successtraerPrimero(data) {
        if (data.estado_p === 200) {
            this.llenar(data.data);
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro el registro.', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'Error Obteniendo el registro', 'error');
            }
        }
    }

    traerUltimo() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbodegasnit', operacion: '4', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerUltimo,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successtraerUltimo(data) {
        if (data.estado_p === 200) {
            this.llenar(data.data);
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }
/*             else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            } */
        }
    }

    llenar(data) {
   
        this.getField('activos_fijos_bodegas_nitsx_sedes_id').setValue(data[0].activos_fijos_bodegas_nitsx_sedes_id);
        this.getField('nitsx_sedes_id').setValue(data[0].nitsx_sedes_id);
        this.getField('activos_fijos_bodegas_id').setValue(data[0].activos_fijos_bodegas_id);
        this.getField('codigo_bodega').setValue(data[0].codigo_bodega);
        this.getField('descripcion_bodega').setValue(data[0].descripcion_bodega);
        this.getField('tipo_bodega').setValue(data[0].tipo_bodega);
        this.getField('nit').setValue(data[0].nit);
        this.getField('sede').setValue(data[0].sede);
        this.getField('nombre').setValue(data[0].nombre);
        this.getField('estadoactivo_id').setValue(data[0].estadoactivo_id);
        this.getField('fecha_inicial').setValue(data[0].fecha_inicial);
        this.getField('fecha_final').setValue(data[0].fecha_final);
    }




    establecerPropiedades(sObjetos, sPropiedad, sValor) {
        const array = sObjetos.split(',');
        array.forEach((element) => {
            if (sPropiedad === 'disable') {
                if (sValor === 'true') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setDisabled(true);
                }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setDisabled(false);
                }
            }
            else if (sPropiedad === 'visible') {
                if (sValor === 'true') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setVisible(true);
                }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setVisible(false);
                }
            }
            else if (sPropiedad === 'value') {
                this.getField(this.arrayObjetos.get(parseInt(element))).setValue(sValor);
            }
            else if (sPropiedad === 'valid') {
                if (this.getField(this.arrayObjetos.get(parseInt(element))).isValid()) {
                    //ok
                }
                else {
                    this.bHayErrores = true;
                }
            }
            else if (sPropiedad === 'foco') {
                if (sValor === 'rejilla') { }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).input.focus();
                }
            }
            else if (sPropiedad === 'error') {
                if (sValor === 'false') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setError(false, '');
                }
            }
        });
    }

    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > 2) {
                decimal = (Number(number).toFixed(2) + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    //imprimir------->


  mostrarMensajeNoHayDatos(){
    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
    this.getField('confirmModalCustom').toggle(true);
}





    mostrarMensajeAdicional(mensaje){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Compras', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

}
FormJaivana.addController("serlog-activosfijosbodegasnit", CustomActivosFijosBodegasNitSxSedes);
export default CustomActivosFijosBodegasNitSxSedes